export const DISPLAY_TEXT = {
  objectConnection: "Object Connection(s)",
  back: "Back",
  next: "Next",
  cancel: "Cancel",
  checkin: "Check-in",
  checkinNew: "Check-in New",
  checkinNewRev: "Check-in New Revision",
  selectedObjects: "Selected Object Connection(s)",
  recent: "Recently Used",
  searchObjects: "Search Object Connection(s)",
};

export const TAB_KEY = {
  root: "root",
  checkinNewBasic: "2",
  checkinNewObjCon: "3",
  checkinNewSelectedObj: "3.1",
  checkinNewRecentObj: "3.2",
  checkinNewAdvanceObj: "3.3",
};

export const DATA_LOADING_STATUS = {
  completed: "Completed",
  loading: "Loading",
  nodata: "NoData",
  error: "Error",
};

/** Message shown in the check-in loading dialog */
export const CHECKIN_LOADING_MESSAGE = "Document check-in in progress…";

/** Message shown after successful check-in while OneDrive metadata is being updated */
export const ONEDRIVE_UPDATE_MESSAGE = "Updating OneDrive document…";
